<template>
  <SkeletonBlock
    :is-active="categoryStore.isSkeletonActive"
    :width="width"
    :height="48"
  >
    <slot />
  </SkeletonBlock>
</template>

<script setup lang="ts">
  import { SkeletonBlock } from '@experience/core-skeleton-lib';
  import { useScreenSize } from '@experience/shared';
  import { useCategoryStore } from '@/shared/store';
  import { computed } from 'vue';

  const { isMobile } = useScreenSize();

  const width = computed(() => {
    if (isMobile.value) {
      return 'calc(50% - 4px)';
    }

    return 210;
  });

  const categoryStore = useCategoryStore();
</script>
